import { PAYMENT_METHODS_CODES } from "constants/paymentMethodsConst";
import { ServerPaymentMethod } from "utils/transformPaymentMethods";
import { CurrencyType } from "./Currency";

export enum PAYMENT_TYPES {
  DEPOSIT = "deposit",
  WITHDRAW = "withdraw",
}

export enum PAYMENT_RESULT_ENUM {
  SUCCESS,
  FAILED,
  WAIT,
}

export enum PAYMENT_METHODS_ENUM {
  ANINDA_HAVALE = "aninda_havale",
  AZARPAY = "azarpay",
  AZARPAY_VALERPAY = "vp-credit-card",
  BANK_CARDS_TRY = "bank_cards_try",
  BANKTRANSFER = "bank_transfer_manual",
  WP_BKASH = "bkash",
  WP_NAGAD = "nagad",
  BKASH = "bkash_p2p",
  BKASH_P2C = "bkash_p2c",
  CEPBANK = "cepbank",
  COREFY = "bank-cards",
  CC = "credit_card",
  TROY = "troy_credit_card",
  CONSTANTPOS_GOOGLE = "pm.constantpos.upi.googlepay",
  CONSTANTPOS_PHONPE = "pm.constantpos.upi.phonpe",
  CONSTANTPOS_PAYTM = "pm.constantpos.upi.paytm",
  ZENPAY_GOOGLE = "pm.zenpay.upi.googlepay",
  ZENPAY_PHONEPE = "pm.zenpay.upi.phonepe",
  ZENPAY_PAYTM = "pm.zenpay.upi.paytm",
  EASYPAISA = "easypaisa",
  EXPAY = "expay",
  EXPRESS_HAVALE = "express_havale",
  HAVALE_HERA = "bank_transfer",
  HAVALE_VIP = "vip-havale",
  INSTAKK = "instakk",
  IPAY = "ipay_manual",
  IMPS = "imps",
  CP_IMPS = "cp_imps",
  ZenpayIMPS = "pm.zenpay.imps",
  JAZZCASH_PAYKASSMA = "jazzcash",
  KPAY = "kpay",
  MEFETE = "mefete",
  MPESA = "mpesa",
  NAGAD = "nagad_p2p",
  NAGAD_P2C = "nagad_p2c",
  OLD_BACK = "old_back",
  PAPARA = "papara",
  PAYFIX = "payfix",
  PAYTM = "paytm",
  PHONEPE = "phone_pe",
  UPI_W = "upi_wallet",
  UPI_L = "upi_wallet_l",
  ROCKET = "rocket",
  UPAY = "upay_manual",
  UPIS = "upis",
  UPIV_GOOGLE = "upi_v_google",
  UPIV_PHONEPE = "upi_v_phonepe",
  UZCARD = "uzcard",
  UZCARD_PAYCOS = "paycos",
  WAVEPAY = "wavepay",
  CASHIX_BKASH = "cashix_bkash_p2c",
  CAHSIX_NAGAD = "cashix_nagad_p2c",
  APAY_NAGAD = "nagad_a",
  APAY_BKASH = "bkash_a",
  AP_IMPS = "ap_imps",
  VALERPAY_M10 = "m10",
  VALERPAY_MPAY = "mpay",
  SMARTPROPAY_M10 = "spp_m10",
  SMARTPROPAY_MPAY = "spp-mpay",
  MAKSIPARA_BANKTRANSFER = "mp-bank-transfer",
  MAKSIPARA_PEPPARA = "mp-peppara",
  MAKSIPARA_PAPARA = "mp-papara",
  MAKSIPARA_PAYFIX = "mp-payfix",
  MAKSIPARA_POPYPARA = "mp-popypara",
  MAKSIPARA_PAYBOL = "mp-paybol",
  ESEWA = "ap-esewa",
  KHALTI = "ap-khalti",
  AP_UPAY = "ap-upay",
  AP_JAZZCASH = "ap-jazzcash",
  AP_EASYPAISA = "ap-easypaisa",
  AP_BANKALFALAH = "ap-bankalfalah",
  OCTOPAYS_NAGAD = "oc_nagad",
  OCTOPAYS_BKASH = "oc_bkash",
  CASHIX_VIETQR = "cashix_viet_qr",
  CASHIX_MOMOPAY = "cashix_momo_pay",
  VVP_KREDIKARTI = "vvp-kredikarti",
  BITOLO_BANKTRANSFER = "btl-bank-transfer",
  BITOLO_MOMOPAY = "btl-momopay",
  BITOLO_ZALOPAY = "btl-zalopay",
  BITOLO_VIETTELPAY = "btl-viettelpay",
  BITOLO_VIETQR = "btl-viet-qr",
  WANGUPAY_MOMOPAY = "wp-momo-pay",
  WANGUPAY_VIET_QR = "wp-viet-qr",
  SPAYZ_BANKTRANSFER = "spayz_bank_transfer",
  SPAYZ_VIRTUALACCOUNT = "spayz_virtual_account",
  UMMONEY_KHALTY = "um_money_khalti",
  UMMONEY_ESEWA = "um_money_esewa",
  UMMONEY_CELLPAY = "um_money_cellpay",
  UMMONEY_IMEPAY = "um_money_imepay",
  EASYPAYGAME_JAZZCASH = "easy_pay_game_jazzcash",
  EASYPAYGAME_EASYPAISA = "easy_pay_game_easypaisa",
  PAYOK_MOMOPAY = "pk-momo-pay",
  PAYOK_VIET_QR = "pk-mb-viet-qr",
  PAYOK_VIETCOM_QR = "pk-vietcom-qr",
  PAYOK_TECHCOM_VIET_QR = "pk-techcom-viet-qr",
  PAYOK_ACB_VIET_QR = "pk-acb-viet-qr",
  PAYOK_BIDV_QR = "pk-bidv-qr",
  PAYOK_VIETTEL_PAY = "pk-viettel-pay",
  PAYOK_BANKTRANSFER = "pk-bank-transfer",
  INWIZO_EMANAT = "inwz-emanat",
  INWIZO_M10 = "inwz-m10",
  INWIZO_M10_WALLET = "inwz-m10-wallet",
  INWIZO_M10_BANK_CARD = "inwz-m10-bank-card",
  COREFY_NAGAD = "crf-nagad",
  COREFY_BKASH = "crf-bkash",
  OCTOPAYS_NAGAD_P2P = "oc-nagad-p2p",
  OCTOPAYS_BKASH_P2P = "oc-bkash-p2p",
  BOVA_BANKTRANSFER = "bv-bank-transfer",
  BOVA_CLICKTOSS = "bv-click-toss",
  HAVALE_FAST_MPAY = "mpay-havale-fast-iban",
  HAVALE_MPAY = "mpay-havale",
  CRYPTO_PROCESSING = "process-crypto",
  FLASHPAY_KAKAOPAY = "fp-kakao-pay",
  FLASHPAY_NAVERPAY = "fp-naver-pay",
  CASHIX_EASYPAISA = "cashix-easy-paisa",
  CASHIX_JUZZCASH = "cashix-jazz-cash",
  VEVOPAY_HIZLIHAVALE = "vvp-hizlihavale",
  APAY_NAYAPAY = "ap-naya-pay",
  BETATRANSFER_BANKTRANSFER = "bt-bank-transfer",
  SMARTPROPAY_HAVALEFAST = "spp-havale-fast",
  DZENPAY_EASYPAISA = "dp-easy-paisa",
  DZENPAY_JUZZCASH = "dp-jazz-cash",
  ZOVI_EASYPAISA = "zv-easy-paisa",
  CASHIX_UPI = "cashix-upi",
  CASHIX_IMPS = "cashix-imps",
  IDM_BANKTRANSFER = "idm-bank-transfer",
  FPX_ACERPAY = "acp-fpx",
  COREFY_BANKCARDS = "h2h-bank-cards",
  TEST = "test",
  BONUS = "bonus",
  REFERRAL = "referral",
  MANUAL = "manual",
}

export enum PAYMENT_SYSTEM_ENUM {
  AZARPAY = "azarpay",
  APAY = "apay",
  COREFY = "corefy",
  CONSTANTPOS = "constantpos",
  EPUL = "epul",
  EXPAY = "expay",
  MPAY = "mpay",
  TROY = "troy",
  HAVALE_HERA = "havale-payhera",
  PAYCOS = "paycos",
  PAYFIX = "payfix",
  PAYKASSMA = "paykassma",
  PAYTURKA = "payturka",
  SIMPLEPAY = "simplepay",
  SIMPLE_PAY = "simple-pay",
  SMARTPROPAY = "smart-pro-pay",
  ZOFTPAY = "zoftpay",
  WELLXPAY = "wellxpay",
  CASHIX = "cashix",
  ZENPAY = "zenpay",
  VALERPAY = "valerpay",
  MAKSIPARA = "maksipara",
  OCTOPAYS = "octopays",
  VEVOPAY = "vevopay",
  BITOLO = "bitolo",
  WANGUPAY = "wangupay",
  SPAYZ = "spayz",
  UMMONEY = "um_money",
  EASYPAYGAME = "easy_pay_game",
  CRYPTO = "crypto",
  PAYOK = "payok",
  INWIZO = "inwizo",
  BOVA = "bova",
  FLASHPAY = "flashpay",
  BETATRANSFER = "betatransfer",
  DZENPAY = "dzenpay",
  ZOVI = "zovi",
  IDM = "idm",
  ACERPAY = "acerpay",
  TEST = "test",
  BONUS = "1",
  REFERRAL = "3",
  MANUAL = "4",
}

export enum PAYMENT_STEPS {
  DEPOSIT_AMOUNT = "DEPOSIT_AMOUNT",
  WITHDRAW_AMOUNT = "WITHDRAW_AMOUNT",
  TRANSACTION = "TRANSACTION",
  TRANSACTION_ONLY = "TRANSACTION_ONLY",
  TRANSACTION_ERROR = "TRANSACTION_ERROR",
  PAYMENT_PAGE = "PAYMENT_PAGE",
  LOADING = "LOADING",
  PENDING_SUCCESS = "PENDING_SUCCESS",
  ZOVI_SUCCESS = "ZOVI_SUCCESS",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  ATTENTION = "ATTENTION",
  APP_CHOISE = "APP_CHOISE",
  QR_CODE = "QR_CODE",
  CRYPTO = "CRYPTO",
  IDM_SUCCESS = "IDM_SUCCESS",
  CRYPTO_DEPOSIT = "CRYPTO_DEPOSIT",
  CRYPTO_WITHDRAW = "CRYPTO_WITHDRAW",
}

export enum PAYMENT_APPS {
  PAYTM = "PayTM",
  PHONEPE = "PhonePe",
  GOOGLE_PAY = "GooglePay",
}

export enum BANKS_LKR_ENUM {
  AllianceFinance = "Alliance Finance Company PLC",
  AmanaBankPLC = "Amana Bank PLC",
  AsiaAssetFinancePLC = "Asia Asset Finance PLC",
  BankOfCeylon = "Bank of Ceylon",
  BankOfChinaLimited = "Bank of China Limited",
  BimputhFinancePLC = "Bimputh Finance PLC",
  CBCFinanceLimited = "CBC Finance Limited",
  CargillsBankLimited = "Cargills Bank Limited",
  CentralFinancePLC = "Central Finance PLC",
  CitiBankNA = "Citi bank N. A.",
  CitizenDevelopmentBank = "Citizen Development Bank",
  CommercialBankPLC = "Commercial Bank PLC",
  DFCCBankPLC = "DFCC Bank PLC",
  DeutscheBankAG = "Deutsche Bank AG",
  DialogFinancePLC = "Dialog Finance PLC",
  HDFCBank = "HDFC Bank",
  HNBFinancePLC = "HNB Finance PLC",
  HSBC = "HSBC",
  HabibBankLimited = "Habib Bank Limited",
  HattonNationalBankPLC = "Hatton National Bank PLC",
  IndianBank = "Indian Bank",
  IndianOverseasBank = "Indian Overseas Bank",
  KanrichFinanceLimited = "Kanrich Finance Limited",
  LBFinancePLC = "L B Finance PLC",
  LOLCDevelopmentFinance = "LOLC Development Finance",
  LOLCFinancePLC = "LOLC Finance PLC",
  LankaCreditFinanceLTD = "Lanka Credit Finance LTD",
  MCBBankLimited = "MCB Bank Limited",
  MercantileInvestments = "Mercantile Investments",
  MerchantBankPLC = "Merchant Bank PLC",
  NationalDevelopmentBank = "National Development Bank",
  NationalSavingsBank = "National Savings Bank",
  PanAsiaBankPLC = "Pan Asia Bank PLC",
  PeopleLeasingFinance = "People Leasing Finance",
  PeoplesBank = "Peoples Bank",
  PolgahawelaCoOpBank = "Polgahawela Co-op Bank",
  PublicBankBerhad = "Public Bank Berhad",
  RegionalDevelopmentBank = "Regional Development Bank",
  RichardPiersFinance = "Richard Piers Finance",
  SampathBankPLC = "Sampath Bank PLC",
  SarvodhayaFinance = "Sarvodhaya Finance",
  SenkadagalaFinancePLC = "Senkadagala Finance PLC",
  SeylanBankPLC = "Seylan Bank PLC",
  SingerFinancePLC = "Singer Finance PLC",
  SiyapathaFinancePLC = "Siyapatha Finance PLC",
  StateMortgageBank = "State Mortgage Bank",
  UnionBankOfColomboPLC = "Union Bank Of Colombo PLC",
  VallibelFinancePLC = "Vallibel Finance PLC",
  SanasaDevelopmentBank = "Sanasa Development Bank",
  FintrexFinanceLimited = "Fintrex Finance Limited",
}

export enum BANKS_INR_ENUM {
  AirtelPaymentsBankLtd = "Airtel Payments Bank Ltd.",
  AxisBank = "Axis Bank",
  BandhanBankLimited = "Bandhan Bank limited",
  BankOfAmerica = "Bank of America",
  BankOfBahrainAndKuwaitBSC = "Bank of Bahrain and Kuwait B.S.C",
  BankOfBaroda = "Bank of Baroda",
  BankOfIndia = "Bank of India",
  BankOfMaharashtra = "Bank of Maharashtra",
  BarclaysBank = "Barclays Bank",
  BNPParibas = "BNP Paribas",
  CanaraBank = "Canara Bank",
  CatholicSyrianBank = "Catholic Syrian Bank",
  CentralBankOfIndia = "Central Bank of India",
  CitiBank = "Citi bank",
  CityUnionBank = "City Union Bank",
  CreditAgricoleCorporateInvestmentBank = "Credit Agricole Corporate & Investment Bank",
  DCBankLtd = "DCB Bank Ltd.",
  DevelopmentBankOfSingapore = "Development Bank of Singapore",
  DhanalakshmiBank = "Dhanalakshmi Bank",
  EmiratesNBDBankPJSC = "Emirates NBD Bank (P J S C)",
  FederalBank = "Federal Bank",
  FinoPaymentsBank = "Fino Payments Bank",
  ICICIBank = "ICICI Bank",
  HSBC = "HSBC",
  HDFCBank = "HDFC Bank",
  IDBIBank = "IDBI Bank",
  IDFCBank = "IDFC bank",
  IndiaPostPaymentsBankLimited = "India Post Payments bank Limited",
  IndianBank = "Indian Bank",
  IndianOverseasBank = "Indian Overseas Bank",
  IndusindBank = "Indusind Bank",
  JammuAndKashmirBank = "Jammu And Kashmir Bank",
  JIOPaymentsBank = "JIO Payments Bank",
  KarnatakaBank = "Karnataka Bank",
  KarurVysyaBank = "Karur Vysya Bank",
  KhardahCooperativeBankLtd = "Khardah Cooperative Bank Ltd",
  KotakMahindraBank = "Kotak Mahindra Bank",
  NSDLPaymentsBankLtd = "NSDL PAYMENTS BANK LTD",
  PaytmPaymentsBank = "Paytm Payments Bank",
  PunjabAndSindBank = "Punjab and Sind Bank",
  PunjabNationalBank = "Punjab National Bank",
  RamrajyaSahakariBankLtd = "RAMRAJYA SAHAKARI BANK LTD",
  RatnakarBank = "Ratnakar Bank",
  SBMBankIndiaLimited = "SBM BANK (INDIA) LIMITED",
  ShinhanBank = "Shinhan Bank",
  SriSatyaSaiNagrikSahakariBankMydt = "SRI SATYA SAI NAGRIK SAHAKARI BANK, MYDT",
  SouthIndianBank = "South Indian Bank",
  StandardCharteredBank = "Standard Chartered Bank",
  StateBankOfIndia = "State Bank of India",
  TamilnadMercantileBank = "Tamilnad Mercantile Bank",
  TheGoaUrbanCooperativeBankLtd = "The Goa Urban Co-Operative Bank Ltd.",
  TheRayatSevakCooperativeBankLimited = "The Rayat Sevak Co-Operative Bank Limited",
  TirumalaCooperativeUrbanBankLtd = "TIRUMALA CO-OPERATIVE URBAN BANK LTD",
  UCOBank = "UCO Bank",
  UnionBankOfIndia = "Union Bank Of India",
  YesBankLtd = "Yes Bank Ltd",
}

export enum BANKS_TRY_ENUM {
  AKBANK = 1,
  AKTIFBANK = 26,
  ALBARAKA_TURK = 4,
  ALTERNATIF_BANK = 5,
  ANADOLUBANK = 6,
  BURGAN_BANK = 7,
  DENIZBANK = 8,
  ENPARA = 25,
  FINANSBANK = 13,
  GARANTI_BANKASI = 2,
  HSBC_BANK = 10,
  HALKBANK = 15,
  ING = 11,
  ISBANK = 16,
  KUVEYTTURK = 12,
  ODEABANK = 27,
  SEKERBANK = 14,
  TEB = 19,
  TURKIYE_FINANS = 20,
  VAKIFBANK = 17,
  YAPIKREDI = 21,
  ZIRAAT_BANKASI = 18,
  ZIRAAT_KATLIM = 22,
  FIBABANKA = 9,
}

export enum MPAY_BANKS_TRY_ENUM {
  FAST_EFT = 23,
  VAKIF_KATILIM = 21,
  TURKIYE_FINANS = 16,
  TEB = 11,
  GARANTI_BANKASI = 2,
  KUVEYTTURK = 10,
  ZIRAAT_BANKASI = 5,
  AKBANK = 3,
  HALKBANK = 13,
  ISBANK = 1,
  FIBABANKA = 19,
  ALBARAKA_TURK = 12,
  ING = 20,
  ZIRAAT_KATLIM = 42,
  DENIZBANK = 7,
  ODEABANK = 15,
  VAKIFBANK = 4,
  SEKERBANK = 9,
  YAPIKREDI = 6,
  FINANSBANK = 8,
}

export enum SMARTPROPAY_BANKS_TRY_ENUM {
  ZIRAAT_BANKASI = 1,
  HALKBANK = 2,
  VAKIFBANK = 3,
  AKBANK = 4,
  TEB = 5,
  SEKERBANK = 6,
  ISBANK = 7,
  YAPIKREDI = 8,
  ENPARA = 9,
  DENIZBANK = 10,
  FINANSBANK = 11,
  HSBC = 12,
  ING = 13,
  ODEABANK = 14,
  GARANTI_BANKASI = 15,
  ALBARAKA_TURK = 16,
  KUVEYTTURK = 18,
  TURKIYE_FINANS = 19,
  PTTBANK = 20,
  BURGANBANK = 25,
  FIBABANKA = 26,
  AKTIF_BANK = 27,
  ALTERNATIF_BANK = 28,
  FAST_BANK = 29,
  FASTBANK_ALT = 30,
}

export enum BANKS_MAKSIPARA_ENUM {
  AKBANK = "9",
  ALBARAKA = "14",
  ANADOLU_BANK = "15",
  BURGANBANK = "19",
  DENIZBANK = "13",
  ENPARA = "7",
  FIBABANK = "22",
  GARANTI_BANKASI = "1",
  HALKBANK = "11",
  ING_BANK = "4",
  IS_BANKASI = "2",
  KUVEYT_TURK = "10",
  ODEABANK = "23",
  QNB_FINANSBANK = "6",
  SEKERBANK = "18",
  TEB = "5",
  TURKIYE_FINANS = "12",
  VAKIFBANK = "43",
  YAPI_KREDI = "8",
  ZIRAAT_BANKASI = "3",
}

export enum BANKS_SPAYZ_ENUM {
  BUSANBANK = "10099",
  CITIBANK = "10113",
  CREDITUNION = "10107",
  DAEGUBANK = "10098",
  SAVINGSBANK = "10101",
  IBK = "10096",
  JEJUBANK = "10111",
  JEONBUKBANK = "10110",
  KAKAOBANK = "10102",
  KBANK = "10114",
  KDB = "10100",
  KEB = "10430",
  KEBHANABANK = "10112",
  KYUNGAMBANK = "10027",
  KOOKMINBANK = "10095",
  KWANGJU = "10094",
  KYONGNAM = "10428",
  AGRICALTURAL = "10272",
  NACUFOK = "10432",
  NH = "10429",
  NONGHYUP = "10097",
  POST = "10109",
  SAEMAEUL = "10103",
  SC = "10105",
  SHINHAN = "10106",
  SUHYUP = "10104",
  TOSS = "10410",
  WOORI = "10108",
}

export enum BANKS_AZ_ENUM {
  UNIBANK = 0,
  AZERTURKBANK = 1,
  PASABANK = 2,
  EXPRESSBANK = 3,
  BANKRESPUBLIKA = 4,
  BANKOFAKU = 5,
  YELOBANK = 6,
  GUNAYBANK = 7,
  TURANBANK = 8,
  RABITABANK = 9,
  ACCESSBANK = 10,
  XALQBANK = 11,
  MUGANBANK = 12,
  ABB = 13,
  AFBBANK = 14,
  ASBBANK = 15,
  ZIRAATBANKAZE = 16,
  YAPIKREDIBANKAZE = 17,
  BANKBTB = 18,
  LEOBANK = 19,
  KAPITALBANK = 20,
}

export enum ANINDA_HAVALE_BANK {
  GarantiBankasi = 1,
  Akbank = 2,
  DenizBank = 3,
  FinansBank = 4,
  IsBankasi = 5,
  Teb = 7,
  Vakifbank = 9,
  YapiKredi = 11,
  ZiraatBankasi = 13,
  IngBank = 15,
  Sekerbank = 17,
  KuveytTurk = 19,
  TurkiyeFinans = 25,
  Halkbank = 27,
  AlbarakaTurk = 30,
  Enpara = 32,
}

export enum BANKS_EXPRESS_ENUM {
  AKBANK = "AKBANK",
  DENIZBANK = "DENİZBANK",
  ENPARA = "Enpara",
  FINANSBANK = "FİNANSBANK",
  GARANTI_BANKASI = "GARANTİ BANKASI",
  ING = "İNG",
  ISBANK = "İŞ BANKASI",
  KUVEYTTURK = "KUVEYTTÜRK",
  TEB = "TEB",
  TURKIYE_FINANS = "Türkiye Finans",
  VAKIFBANK = "VAKIFBANK",
  YAPIKREDI = "YAPI KREDİ",
  ZIRAAT_BANKASI = "ZİRAAT BANKASI",
}

export enum BANKS_VIETNAM_ENUM {
  TECHCOMBANK = "TCB",
  SACOMBANK = "SCM",
  VIETCOMBANK = "VCB",
  ASIACOMMERCIAL = "ACB",
  DONGABANK = "DAB",
  VIETINBANK = "VTB",
  BIDVBANK = "BIDV",
  EXIMBANK = "EXIM",
  AGRIBANK = "VBARD",
}

export enum BANKS_BOVA_ENUM {
  ABN_AMRO = "1",
  BANK_OF_AMERICA = "2",
  BNK_SECURITIES_CO = "3",
  BNP_PARIBAS = "4",
  BNP_PKR = "5",
  BOOKOOK = "6",
  BANK_OF_KOREA = "7",
  BARCLAYS = "8",
  BUSAN_BANK = "9",
  CHINA_CONSTRUCTION_BANK = "10",
  CITIBANK_KOREA = "11",
  CREDIT_UNION = "12",
  DAESHIN = "13",
  DB_FINANCIAL_INVESTMENT_CO_LTD = "14",
  DEUTSCHE_BANK = "15",
  DMS_BANK = "16",
  DAEGU_BANK = "17",
  HANKOOK = "18",
  HANWHA = "19",
  HITOOJA = "20",
  HSBC = "21",
  HANA_FINANCIAL_INVESTMENT = "22",
  HYUNDAI_MOTOR_SECURITIES = "23",
  IBK = "24",
  ING = "25",
  INDUSTRIAL_COMMERCIAL_BANK_OF_CHINA = "26",
  JPMORGAN_CHASE = "27",
  JEJU_BANK = "28",
  JEONBUK_BANK = "29",
  K_BANK = "30",
  KB_SECURITIES = "31",
  KDB = "32",
  KEB_HANA_BANK = "33",
  KIWOOM = "34",
  KOREAN_FEDERATION_OF_COMMUNITY_CREDIT_COOPERATIVES = "35",
  KTB_INVESTMENT = "36",
  KYOBO_TRADE = "37",
  KAKAO_BANK = "38",
  KOOKMIN_BANK = "39",
  KOREA_DEVELOPMENT_BANK = "40",
  KOREA_FOSS_SECURITIES = "41",
  KWANGJU_BANK = "42",
  KYUNGNAM_BANK = "43",
  MERITZ = "44",
  MIRAEASSET_DAEWOO = "45",
  NH_INVESTMENT = "46",
  NATIONAL_AGRICULTURAL_COOPERATIVE_FEDERATION = "47",
  NONGHYUP_BANK = "48",
  POST_BANK = "49",
  SAMSUNG = "50",
  SANLIM = "51",
  SC_FIRST_BANK = "52",
  SHINYOUNG = "53",
  SKTRADE = "54",
  SAEMAEUL_BANK = "55",
  SHINHAN_BANK = "56",
  SHINHAN_INVESTMENT_CORP = "57",
  STANDARD_CHARTERED_BANK = "58",
  SUHYUP_BANK = "59",
  WOORI_BANK = "60",
  YOUJIN_TRADE = "61",
  YUANTA = "62",
  DMSGOD_MUTUAL_SAVINGS_BANK = "63",
  EBEST_INVESTMENT_SECURITIES_CO_LTD = "64",
  KAKAOPAY_SECURITIES = "65",
  TOSS = "100",
  TOSS_SEC = "101",
  NATIONAL_CREDIT_UNION = "102",
  DAISHIN = "103",
  KISEUROPE = "104",
  HANVA_INVEST = "105",
  KIWOOM_SEC = "106",
  KFCC = "107",
  DAOLSECURITIES = "109",
  WOORIIB = "110",
  SAMSUNGSECURITIES = "111",
  SYFUND = "112",
  LS_SEC = "113",
}

export enum BANKS_FPX_ENUM {
  AFFIN_BANK = "FPX_AFF",
  ALLIANCE_BANK = "FPX_ALB",
  AMBANK = "FPX_AMB",
  BANK_ISLAM = "FPX_BIMB",
  BANK_RAKYAT = "FPX_BKR",
  BSN_BANK = "FPX_BSN",
  CIMB_BANK = "FPX_CIMB",
  HONG_LEONG_BANK = "FPX_HLB",
  HSBC_BANK = "FPX_HSBC",
  MAYBANK = "FPX_MBB",
  OCBC_BANK = "FPX_OCBC",
  PUBLIC_BANK = "FPX_PBB",
  RHB_BANK = "FPX_RHB",
  STANDARD_CHARTERED_BANK_MALAYSIA_BERHAD = "FPX_SCTB",
  UOB_BANK = "FPX_UOB",
  AGRO_BANK = "FPX_AGROB",
  BANK_MUAMALAT_MALAYSIA_BERHAD = "FPX_BMMB",
  BANK_OF_CHINA = "FPX_BOCM",
  KUWAIT_FINANCE_HOUSE = "FPX_KFH",
}

export enum BANKS_VIETNAM_PAYOK_ENUM {
  ABBANK = 1,
  ACB = 2,
  AGRIBANK = 3,
  VIETCAPITALBANK = 4,
  BAOVIETBANK = 5,
  BIDV = 6,
  DONGABANK = 7,
  EXIMBANK = 8,
  GPBANK = 9,
  HDBANK = 10,
  HONGLEONGBANK = 11,
  INDOVINA = 12,
  KIENLONGBANK = 13,
  LIENVIETPOSTBANK = 14,
  MARITIMEBANK = 15,
  MBBANK = 16,
  NAVIBANK = 17,
  OCB = 18,
  OCEANBANK = 19,
  PGBANK = 20,
  PVCOMBANK = 21,
  SACOMBANK = 22,
  SAIGONBANK = 23,
  SCB = 24,
  SEABANK = 25,
  SHB = 26,
  SHINHANBANK = 27,
  TECHCOMBANK = 28,
  TPBANK = 29,
  UOB = 30,
  VIETCOMBANK = 31,
  VIBBANK = 32,
  PUBLICBANK = 33,
  VIETABANK = 34,
  VIETBANK = 35,
  VIETINBANK = 36,
  VPBANK = 37,
  VIETNAMRUSSIABANK = 38,
  WOORIBANK = 39,
  BACABANK = 3483,
  NAMABANK = 3487,
  CIMB = 3489,
  NONGHYUPBANKHN = 3492,
  DBSHCM = 3493,
  COOPBANK = 3494,
  HSBC = 3495,
  CAKE = 3496,
  UBANK = 3497,
  MHB = 3498,
  STANDARDCHARTERED = 3499,
  CBBANK = 3500,
  IBKHANOI = 3501,
  IBKHCM = 3502,
  KOOKMINHN = 3503,
  VIETCREDIT = 3505,
  MIRAEASSET = 3507,
  KEBHANAHCM = 3508,
  KEBHANAHN = 3509,
  KOOKMINHCM = 3510,
  KBANKHCM = 3511,
  VIETTELMONEY = 3512,
  VNPTMONEY = 3513,
}

export type PaymentMethodsQueryArgs = {
  type: "deposit" | "withdraw";
};

export type BanksMethodsQueryArgs = {
  paymentMethods: PAYMENT_METHODS_CODES;
};

export type PaymentAppsType = {
  id?: string;
  appName: string;
  appLogo: string;
  prefix?: string;
};

export type PaymentsResponseType = {
  statusCode: number;
  payments: PaymentsResponseDataType;
};

export type PaymentsResponseDataType = {
  id: number;
  name: string;
  icon: string;
  link: string;
};

export type LimitType = {
  min: number;
  max?: number;
};

export type PaymentMethodsNames =
  | "AnindaHavale"
  | "Azarpay"
  | "AzarpayValerpay"
  | "BankCardsTRY"
  | "BankTransfer"
  | "BKash"
  | "BKashP2C"
  | "CepBank"
  | "Constantpos"
  | "ConstantposGooglePay"
  | "ConstantposPhonePe"
  | "ConstantposPayTM"
  | "ZenpayGooglePay"
  | "ZenpayPhonePe"
  | "ZenpayPayTM"
  | "ZenpayIMPS"
  | "Corefy"
  | "CC"
  | "Easypaisa"
  | "ExPay"
  | "ExpressHavale"
  | "HavaleHera"
  | "HavaleVIP"
  | "Ipay"
  | "IMPS"
  | "CP_IMPS"
  | "InstaKK"
  | "Kpay"
  | "Mefete"
  | "Mpesa"
  | "Nagad"
  | "NagadP2C"
  | "Papara"
  | "Payfix"
  | "Rocket"
  | "Upay"
  | "UpiS"
  | "UPIVGoogle"
  | "UPIVPhonePe"
  // | 'UPIVPayTm'
  | "UZCard"
  | "UZCardPaycos"
  | "WavePay"
  | "PhonePe"
  | "Paytm"
  | "UpiWallet"
  | "UpiWallet_L"
  | "UpiWallet_M"
  | "UpiWallet_IB"
  | "UpiWallet_HB"
  | "UpiWallet_IN"
  | "PhonePe"
  | "JazzcashPaykassma"
  | "Test"
  | "WP_BKash"
  | "WP_Nagad"
  | "Referral"
  | "Manual"
  | "Bonus"
  | "CashixBKash"
  | "CashixNagad"
  | "ApayNagad"
  | "ApayBKash"
  | "AP_IMPS"
  | "Troy"
  | "M10"
  | "VP_MPAY"
  | "SmartProPayM10"
  | "SmartProPayMPAY"
  | "MaksiparaBankTransfer"
  | "MaksiparaPeppara"
  | "MaksiparaPapara"
  | "MaksiparaPayfix"
  | "MaksiparaPopypara"
  | "MaksiparaPaybol"
  | "ApayEsewa"
  | "ApayKhalti"
  | "ApayUpay"
  | "OctopaysNagad"
  | "OctopaysBkash"
  | "Spayz"
  | "UmMoney";

export type PaymentMethodsType = {
  [key in PaymentMethodsNames]: PaymentMethodType;
};

export type PaymentMethodType = {
  code: PAYMENT_METHODS_CODES;
  slug: PAYMENT_METHODS_ENUM;
  icon: string;
  name: string;
  currency?: string;
  system: PAYMENT_SYSTEM_ENUM;
  limit: {
    deposit: LimitType;
    withdraw: LimitType;
  };
  amountPreset: string[];
  defaultValue: string;
  status?: string;
  steps: {
    deposit: Array<keyof typeof PAYMENT_STEPS>;
    withdraw: Array<keyof typeof PAYMENT_STEPS>;
  };
};

export type SetMethodType = {
  method: PaymentMethodType;
  type: PAYMENT_TYPES;
};

export type MethodsResponseDataType = {
  id: number;
  code: string;
  name: string;
  status: string;
  currencyIsoCode: string;
};

export type MethodsResponseType = {
  statusCode: number;
  paymentMethods: ServerPaymentMethod[];
};

export type BanksResponseType = {
  statusCode: number;
  paymentMethods: BanksApiResponse;
};

export type BanksApiResponse = {
  banks: BanksResponsePaymentMethodCode[];
};

export type BanksResponsePaymentMethodCode = {
  title: string;
  logo: string;
  meta: {
    max: string;
    min: string;
    active: string;
    waitingTime: string;
    minimumWithdrawFee: string;
    processingFee: string;
    networkFee: string;
    [key: string]: string;
  };
};

export type PaymentApiRequest = {
  method: PAYMENT_METHODS_ENUM;
  amount?: number;
  clientId?: string;
};

export type PaymentApiResponse = {
  transactionId?: string;
  status: string;
  statusCode: number;
};

export type SimplepayDepositRequest = PaymentApiRequest & {
  successUrl?: string;
  failUrl?: string;
  cancelUrl?: string;
  lang?: string;
  phoneNumber?: string;
  accountName?: string;
  accountNumber?: string;
  name?: string;
  surname?: string;
  birthdate?: string;
  firstName?: string;
  lastName?: string;
  login?: string;
  email?: string;
};

export type SimplepayDepositResponse = PaymentApiResponse & {
  data: any;
  transactionId: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type SimplepayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  phone?: string;
  accountName?: string;
  accountNumber?: string;
  bankCode?: string;
  name?: string;
  surname?: string;
  firstName?: string;
  lastName?: string;
  paparaAccountNumber?: number;
  branchCode?: string;
  IBAN?: string;
};

export type SimplepayWithdrawResponse = PaymentApiResponse;

export type UpiVFastDepositRequest = PaymentApiRequest & {
  upiAddress: string;
};

export type UpiVFastDepositResponse = PaymentApiResponse & {
  paymentPageUrl: string;
  orderId: string;
};

export type ConstantposDepositRequest = PaymentApiRequest & {
  account: string;
  locale: string;
  returnUrl: string;
  paymentMethodCode: string;
};

export type ConstantposDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type ZenpayDepositRequest = PaymentApiRequest & {
  paymentMethodCode: string;
};

export type WangupayDepositResponse = PaymentApiResponse;
export type WangupayDepositRequest = PaymentApiRequest;

export type ZenpayDepositResponse = PaymentApiResponse & {
  paymentPageUrl: string;
};

export type ZenpayWithdrawRequest = {
  amount: number;
  accountHolderName: string;
  bankName: string;
  ifscCode: string;
  accountNumber: number | null;
  paymentMethodCode: string;
};

export type ZenpayWithdrawResponse = PaymentApiResponse;

export type ConstantposWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  accountNumber?: string;
  returnUrl?: string;
  ifscCode?: string;
};

export type ConstantposWithdrawResponse = PaymentApiResponse;

export type ValerpayDepositRequest = PaymentApiRequest & {
  account: string;
  successUrl: string;
  rejectUrl: string;
};

export type ValerpayDepositResponse = PaymentApiResponse & {
  paymentUrl?: string;
};

export type ValerpayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  walletNumber?: string;
  cardNumber?: string;
  expirationDate?: string;
  bank?: string;
};

export type ValerpayWithdrawResponse = PaymentApiResponse;

export type OctopaysDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  failedReturnUrl?: string;
};

export type OctopaysDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};

export type OctopaysWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  wallet?: string;
};

export type OctopaysWithdrawResponse = PaymentApiResponse;

export type BitoloDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  firstName?: string;
  lastName?: string;
};

export type BitoloDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};

export type BitoloWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  accountNumber?: string;
  bank?: string;
  swiftCode?: string;
  firstName?: string;
  lastName?: string;
  norificationUrl?: string;
};

export type BitoloWithdrawResponse = PaymentApiResponse;

export type MpayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  fullName: string;
  amount: number;
  bankCode: number;
  IBAN: string;
};

export type MpayWithdrawResponse = PaymentApiResponse;

export type BetatransferDepositRequest = PaymentApiRequest & {
  successUrl?: string;
  failUrl?: string;
  cancelUrl?: string;
  returnUrl?: string;
  lang?: string;
  name?: string;
  surname?: string;
  firstName?: string;
  lastName?: string;
};

export type BetatransferDepositResponse = PaymentApiResponse & {
  data: any;
  transactionId: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type BetatransferWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  fullName: string;
  amount: number;
  bankCode: number;
  IBAN: string;
};

export type BetatransferWithdrawResponse = PaymentApiResponse;

export type BovaWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  accountNumber?: string;
  bank?: string;
  firstName?: string;
  lastName?: string;
  norificationUrl?: string;
};

export type BovaWithdrawResponse = PaymentApiResponse;

export type SpayzDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  firstName?: string;
  lastName?: string;
};

export type SpayzDepositResponse = PaymentApiResponse;

export type SpayzWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  accountNumber?: string;
  bankCode?: string;
  firstName?: string;
  lastName?: string;
  accountName?: string;
};

export type SpayzWithdrawResponse = PaymentApiResponse;

export type PayokWithdrawRequest = PaymentApiRequest & {
  paymentSystem: PAYMENT_METHODS_ENUM;
  accountName: "string";
  accountNumber: "string";
  bankCode: "string";
  personalId: "string";
};

export type PayokWithdrawResponse = PaymentApiResponse;

export type InwizoDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  firstName?: string;
  lastName?: string;
};

export type InwizoDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};

export type InwizoWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  walletNumber?: string;
  bankCardNumber?: string;
};

export type InwizoWithdrawResponse = PaymentApiResponse;

export type BovaDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
};

export type BovaDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};

export type WellxpayDepositRequest = PaymentApiRequest & {
  redirectUrl?: string;
};

export type WellxpayDepositResponse = PaymentApiResponse & {
  transactionId: string;
  paymentUrl?: string;
};

export type WellxpayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  wallet?: string;
};

export type WellxpayWithdrawResponse = PaymentApiResponse;

export type wangupayMomopayDepositResponse = PaymentApiResponse;

export type wangupayMomopayDepositRequest = PaymentApiRequest;

export type SmartProPayDepositRequest = PaymentApiRequest & {
  firstName?: string;
  lastName?: string;
  backUrl?: string;
};

export type SmartProPayDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};

export type SmartProPayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  firstName?: string;
  lastName?: string;
  accountNumber?: string;
  phoneNumber?: string;
};

export type PayokDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
};

export type PayokDepositResponse = PaymentApiResponse & {
  redirectUrl?: string;
};

export type SmartProPayWithdrawResponse = PaymentApiResponse;

export type MaksiparaDepositRequest = PaymentApiRequest & {
  fullName?: string;
  returnUrl?: string;
};

export type MaksiparaDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};
export type VevopayDepositRequest = PaymentApiRequest & {
  fullName?: string;
  returnUrl?: string;
  successUrl: string;
  rejectUrl: string;
};

export type VevopayDepositResponse = PaymentApiResponse & {
  transactionId: string;
  redirectUrl?: string;
};

export type MaksiparaWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  iban?: string;
  identity?: string;
  turkeyId?: string;
  birthDate?: string;
  bank?: string;
  walletNumber?: string;
};

export type MaksiparaWithdrawResponse = PaymentApiResponse;

export type PayturkaDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  failUrl?: string;
  cancelUrl?: string;
  name?: string;
  surname?: string;
  firstName?: string;
  lastName?: string;
};

export type PayturkaDepositResponse = PaymentApiResponse & {
  data: any;
  transactionId: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type PayturkaWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  accountName?: string;
  accountNumber?: string;
  bankCode?: string;
  name?: string;
  surname?: string;
  firstName?: string;
  lastName?: string;
  branchCode?: string;
  IBAN?: string;
};

export type PayturkaWithdrawResponse = PaymentApiResponse;

export type PaykassmaDepositCreateRequest = PaymentApiRequest & {
  successUrl?: string;
  failUrl?: string;
  cancelUrl?: string;
  lang?: string;
  phoneNumber?: string;
  accountName?: string;
  accountNumber?: string;
};

export type PaykassmaDepositCreateResponse = PaymentApiResponse & {
  data: any;
  transactionId: string;
  redirectUrl?: string;
  pluginUrl?: string;
  params: {
    identifier: string;
    account_type?: string;
  };
};

export type PaykassmaDepositActivateRequest = {
  amount?: number;
  paymentMethodId: number;
  remoteTransactionId: string;
  transactionId?: string;
  clientId?: string;
};

export type PaykassmaDepositActivateResponse = PaymentApiResponse;

export type PaykassmaWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  phone?: string;
  accountName?: string;
  accountNumber?: string;
  bankCode?: string;
};

export type PaykassmaWithdrawResponse = PaymentApiResponse;

export type MpayDepositRequest = PaymentApiRequest & {
  successUrl?: string;
  failUrl?: string;
  cancelUrl?: string;
  returnUrl?: string;
  lang?: string;
  name?: string;
  surname?: string;
  firstName?: string;
  lastName?: string;
};

export type MpayDepositResponse = PaymentApiResponse & {
  data: any;
  transactionId: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type TroyDepositRequest = PaymentApiRequest & {
  successUrl?: string;
  failUrl?: string;
  cancelUrl?: string;
  returnUrl?: string;
  lang?: string;
  name?: string;
  surname?: string;
  firstName?: string;
  lastName?: string;
};

export type TroyDepositResponse = PaymentApiResponse & {
  data: any;
  transactionId: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type PaparaDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
};

export type PaparaDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type PaparaWithdrawRequest = {
  firstName: string;
  lastName: string;
  paparaAccountNumber: number;
  amount: number;
};

export type PaparaWithdrawResponse = PaymentApiResponse & {
  message: string;
};

export type HavaleVipDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
};

export type HavaleVipDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type HavaleVipWithdrawRequest = {
  firstName: string;
  lastName: string;
  bankName: string;
  amount: number;
  phoneNumber: string;
  branchCode: string;
  accountNumber: number | null;
  IBAN: string;
};

export type HavaleVipWithdrawResponse = PaymentApiResponse & {
  message: string;
};

export type ExpressHavaleDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
  returnUrl: string;
};

export type ExpressHavaleDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type ExpressHavaleWithdrawRequest = {
  firstName: string;
  lastName: string;
  amount: number;
  bankName: string;
  accountNumber: number | null;
  branchNumber: string;
  internationalBankAccountNumber: string;
  idNumber: string;
  idDate: string;
};

export type ExpressHavaleWithdrawResponse = PaymentApiResponse;

export type HavaleHeraDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
  returnUrl: string;
};

export type HavaleHeraDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type HavaleHeraWithdrawRequest = {
  firstName: string;
  lastName: string;
  amount: number;
  bankId: string;
  internationalBankAccountNumber: string;
};

export type HavaleHeraWithdrawResponse = PaymentApiResponse;

export type BanksResponse = PaymentApiResponse & {
  banks: BankDataResponse[];
};

export type BankDataResponse = {
  id: number;
  name: string;
  logo: string;
  is_active: number;
};

export type AnindaHavaleDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
};

export type AnindaHavaleDepositResponse = {
  success: boolean;
  link: string;
  message: string[];
  statusCode: number;
};

export type AnindaHavaleWithdrawRequest = {
  firstName: string;
  lastName: string;
  amount: number;
  banksId: number;
  IBAN: string;
};

export type AnindaHavaleWithdrawResponse = {
  success: boolean;
  link: string;
  message: string[];
  statusCode: number;
};

export type EpulDepositRequest = PaymentApiRequest & {
  successUrl: string;
  rejectUrl: string;
};

export type EpulDepositResponse = {
  redirectUrl: string;
  statusCode: number;
};

export type EpulWithdrawRequest = {
  amount: number;
  cardNumber: string;
  expire: string;
  successUrl: string;
  rejectUrl: string;
};

export type EpulWithdrawResponse = {
  redirectUrl: string;
  statusCode: number;
};

export type PaycosDepositRequest = PaymentApiRequest & {
  email: string;
  currency: string;
  successUrl: string;
  rejectUrl: string;
};

export type PaycosDepositResponse = {
  success: boolean;
  link: string;
  statusCode: number;
};

export type PaycosWithdrawRequest = {
  amount: number;
  cardNumber: string;
  cardHolderName: string;
  redirectSuccessUrl: string;
  redirectFailUrl: string;
};

export type PaycosWithdrawResponse = {
  success: boolean;
  link: string;
  statusCode: number;
};

export type BankCardsDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
  birthdate: string;
  email: string;
};

export type BankCardsDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type MefeteDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
};

export type MefeteDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type MefeteWithdrawRequest = {
  firstName: string;
  lastName: string;
  amount: number;
  accountNumber: string;
};

export type MefeteWithdrawResponse = PaymentApiResponse;

export type PayfixDepositRequest = PaymentApiRequest & {
  firstName: string;
  lastName: string;
};

export type PayfixDepositResponse = PaymentApiResponse & {
  redirectUrl: string;
};

export type PayfixWithdrawRequest = {
  firstName: string;
  lastName: string;
  amount: number;
  accountNumber: number;
};

export type PayfixWithdrawResponse = PaymentApiResponse & {
  transactionId: string;
  customerTransactionId: string;
  paymentStatus: string;
  message: string;
};

export type CashixDepositRequest = PaymentApiRequest & {
  successUrl: string;
  rejectUrl: string;
  pendingUrl: string;
  locale: string;
};

export type CashixDepositResponse = PaymentApiResponse & {
  success: boolean;
  link?: string;
  transactionId?: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type CashixWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  cardNumber?: string;
};

export type WangupayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  phoneNumber: string;
};

export type CashixWithdrawResponse = PaymentApiResponse;

export type WangupayWithdrawResponse = PaymentApiResponse;

export type ApayDepositRequest = PaymentApiRequest & {
  successUrl: string;
  rejectUrl: string;
  pendingUrl: string;
  locale: string;
};

export type ApayDepositResponse = PaymentApiResponse & {
  success?: boolean;
  statusCode?: number;
  link?: string;
  transactionId?: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type ApayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount: number;
  accountNumber: string;
};

export type ApayWithdrawResponse = PaymentApiResponse;

export type EasypaygameDepositRequest = PaymentApiRequest & {
  successUrl: string;
  rejectUrl: string;
  pendingUrl: string;
  locale: string;
};

export type EasypaygameDepositResponse = PaymentApiResponse & {
  success?: boolean;
  statusCode?: number;
  link?: string;
  transactionId?: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type EasypaygameWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount: number;
  accountNumber: string;
};

export type EasypaygameWithdrawResponse = PaymentApiResponse;

export type UmmoneyDepositRequest = PaymentApiRequest & {
  successUrl: string;
  errorUrl: string;
  cancelUrl: string;
};

export type UmmoneyDepositResponse = PaymentApiResponse & {
  success?: boolean;
  statusCode?: number;
  link?: string;
  transactionId?: string;
  redirectUrl?: string;
  pluginUrl?: string;
};

export type UmmoneyWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount: number;
  walletNumber: string;
  name: string;
};

export type UmmoneyWithdrawResponse = PaymentApiResponse;

export type CorefyDepositRequest = PaymentApiRequest & {
  successUrl: string;
  rejectUrl: string;
  pendingUrl: string;
  firstName?: string;
  lastName?: string;
  locale: string;
};

export type CorefyDepositResponse = PaymentApiResponse & {
  success: boolean;
  link: string;
};

export type CorefyWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount: number;
  firstName: string;
  lastName: string;
  cardNumber: string;
};

export type CorefyWithdrawResponse = PaymentApiResponse & {
  success: boolean;
};

export type ExPayWithdrawRequest = {
  amount: number;
  cardNumber: string;
};

export type ExPayWithdrawResponse = {
  status: string;
  statusCode: number;
  transactionId: string;
};

export type AzarpayDepositRequest = PaymentApiRequest;

export type AzarpayDepositResponse = PaymentApiResponse & {
  link: string;
};

export type AzarpayWithdrawRequest = {
  amount: number;
  firstName: string;
  lastName: string;
  bankId: number;
  cardNo: string;
};

export type AzarpayWithdrawResponse = PaymentApiResponse;

export type PaymentDTOType = {
  method: PaymentMethodType | null;
  account: string;
  accountNumber: string;
  amount: string;
  bankCode: string | null;
  branchCode: string;
  birthdate: string;
  name: string;
  surname: string;
  phone: string;
  iban: string;
  idNumber: string;
  idDate: string;
  ifscCode: string;
  paymentPage: string;
  bkashType: string;
  status: keyof typeof PAYMENT_STEPS;
  type: PAYMENT_TYPES | null;
  transaction: string;
  transactionId: string;
  currency: CurrencyType | null;
  userId: number | null;
  login: string;
  balance: number;
  sumDep: number;
  sumBet: number;
  hasFee: boolean;
  card: string;
  expire: string;
  personalId?: string;
  expDate: string;
  qrCode: string;
  minAmount: number | null;
  cryptoWallet: string;
  cryptoMethod?: BanksResponsePaymentMethodCode | null;
  destinationTag: string;
  isLoading: boolean;
  email?: string;
  bankName: string;
};

export type JazzcashPaykassmaDepositResponse = PaymentApiResponse & {
  link: string;
};

export type JazzcashPaykassmaWithdrawRequest = {
  firstName: string;
  lastName: string;
  amount: number;
  accountNumber: number;
};

export type CryptoDepositRequest = {
  currency: string;
  clientId: string;
};

export type CryptoDepositResponse = {
  statusCode?: number;
  transactionId: string;
  minAmount: number;
  walletAddress: string;
  expDate: string;
  qrCode: string;
  destinationTag?: string;
};

export type CryptoWithdrawRequest = {
  currency: string;
  clientId: string;
  walletAddress: string;
  destinationTag?: string;
  amount: number;
};

export type CryptoWithdrawResponse = PaymentApiResponse;

export type FlashpayDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  phoneNumber?: string;
  email?: string;
};

export type FlashpayDepositResponse = PaymentApiResponse;

export type DzenPayDepositRequest = PaymentApiRequest;
export type DzenPayDepositResponse = PaymentApiResponse;

export type DzenPayWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  amount?: number;
  phone: string;
};

export type DzenPayWithdrawResponse = PaymentApiResponse;

export type ZoviDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  phone?: string;
};

export type ZoviDepositResponse = PaymentApiResponse;

export type ZoviWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  fullName?: string;
  phone: string;
};

export type ZoviWithdrawResponse = PaymentApiResponse;

export type IdmDepositRequest = PaymentApiRequest;

export type IdmDepositResponse = PaymentApiResponse & {
  amount?: string;
  bankName?: string;
  bankAccount?: string;
  fullName?: string;
};

export type IdmWithdrawRequest = {
  paymentSystem: PAYMENT_METHODS_ENUM;
  fullName?: string;
  cardNumber: string;
};

export type IdmWithdrawResponse = PaymentApiResponse;

export type AcerpayDepositRequest = PaymentApiRequest & {
  returnUrl?: string;
  fullName?: string;
  bankId?: string;
};

export type AcerpayDepositResponse = PaymentApiResponse;
